import ApiOptions from '@/datatypes/api-options';

export default class ApiDeleteOptions extends ApiOptions {
  constructor(options) {
    super(options);

    this.method = 'delete';
  }
}
